/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if (window.location.href.includes('/products/')) {
    var node = document.querySelector('[data-size-guide]');
    if (node) {
        var trigger = document.querySelector('.product__sizeguide-toggle');
        var modal = node.querySelector('[data-size]');
        var close = node.querySelectorAll('[data-size-close]');
        var header = document.getElementById('shopify-section-header');

        trigger.classList.remove('hidden');

        close.forEach((i) => {
            i.addEventListener('click', () => {
                node.classList.remove('open');
                header.style.zIndex = '3';
            });
        });

        trigger.addEventListener('click', () => {
            node.classList.add('open');
            header.style.zIndex = '-1';
        });
    }
}

function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toUTCString();

    document.cookie = name + "=" + value + "; " + expires + "; path=/"
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// Fetch products
function fetchAllProducts(i = 1, allProducts = []) {

    Promise.all([
        fetch(`/collections/all?view=linked&page=${i}`, {
            mode: 'no-cors',
            method: 'GET',
            credentials: 'include'
        })
    ]).then(async ([r]) => {
        return await r.text()
    }).then(data => {
        const products = JSON.parse(data)
        allProducts = [...allProducts, ...products]

        if (i === window.allPageCount) {
            localStorage.setItem('allProducts', JSON.stringify(allProducts)) // Save in localStorage
            window.products = JSON.parse(localStorage.getItem('allProducts')) // Save in window object
            setCookie('linkedFetched', true, 30)
            loadLinked();
        } else {
fetchAllProducts(i + 1, allProducts)
        }
    })
}

// Fetch product if not saved already
if (!localStorage.getItem('allProducts') || !getCookie('linkedFetched')) {
    fetchAllProducts()
} else {
    window.products = JSON.parse(localStorage.getItem('allProducts'))

    // Check if product count has changed
    if (window.allProductsCount === window.products.length) {
        loadLinked();
    } else fetchAllProducts()
}

function loadLinked() {
    if (!Array.isArray(window.products)) return;

    document.querySelectorAll('[data-linked-container]').forEach(container => {
        var currentSku = container.dataset.sku || '';
        var styleNumber = currentSku.split(':')[0];
        if (!styleNumber) return;

        container.innerHTML = '';

        var linked = window.products.filter(product =>
            product.sku && product.sku.split(':')[0] === styleNumber
        );

        linked.forEach(product => {
            var colorCode = product.sku.split(':')[1];
            if (!colorCode) return;

            var link = document.createElement('a');
            link.title = product.title;
            link.setAttribute('aria-label', product.title);
            link.href = '/products/' + product.handle;
            link.className = 'product__linked-item swatch-' + colorCode;

            if (product.sku === currentSku) {
                link.classList.add('active');
                link.setAttribute('aria-current', 'page');
            }

            container.appendChild(link);
        });
    });
}

/**
 * Megamenu
 */
var mainMenu = document.getElementById('sidebar-menu')
var megaToggles = mainMenu.querySelectorAll('[data-action="toggle-megamenu"]')
var megaClose = document.querySelectorAll('.gr-mega__header')

megaToggles.forEach(toggle => {
    toggle.addEventListener('click', function () {
        toggle.nextElementSibling.classList.add('active');
        mainMenu.classList.add('menu-active');
        mainMenu.style.backgroundColor = toggle.nextElementSibling.dataset.color
    })
})

megaClose.forEach(toggle => {
    toggle.addEventListener('click', function () {
        toggle.parentElement.classList.remove('active');
        mainMenu.classList.remove('menu-active');
        mainMenu.style.backgroundColor = "#fff"
    })
})


/**
 * Product upsells
 */

var upsellVariantSelect = document.getElementById('upsell-variant-select');
var upsellSelectInner = upsellVariantSelect.querySelector('[data-inner]');
var upsellSelectClose = upsellVariantSelect.querySelector('.upsell-variant-select__close');
var upsellSelectOverlay = upsellVariantSelect.querySelector('.upsell-overlay');
var upsellSelectAtc = upsellVariantSelect.querySelector('[data-atc]');

function upsellAddToCart (id, quantity = 1, elm) {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id, quantity }),
    }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        if (response.ok) {
            document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    variant: id,
                    quantity: quantity
                }
            }));

            closeVariantSelect()
        } else {
            response.json().then(function (content) {
                var errorMessageElement = document.createElement('span');
                errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                errorMessageElement.innerHTML = content['description'];
                elm.insertAdjacentElement('afterend', errorMessageElement);
                setTimeout(function () {
                    errorMessageElement.remove();
                }, 2500);
            });
        }
    });
}

function handleAddToCart () {
    var active = upsellSelectInner.querySelector(':checked');

    upsellAddToCart(active.value, 1, upsellSelectAtc)
}

function closeVariantSelect () {
    upsellVariantSelect.classList.remove('active');
    document.body.classList.remove('no-scroll');
    upsellSelectAtc.removeEventListener('click', handleAddToCart)
}

function getVariantHTML (product) {
    var variantsHTML = '';

    product.variants.forEach(variant => {
        variantsHTML += `<label class="upsell-variant__label">
    <input class="upsell-variant__input u-visually-hidden" type="radio" name="variant" value="${variant.id}"${!variant.available ? ' disabled' : ''}>
    <span>${variant.title}</span>
</label>`
    })

    return `
    <div>${product.options.join(' / ')}</div>
    <div class="upsell-variant__input-wrapper">
        ${variantsHTML}
    </div>
    `
}

function handleUpsell (product) {
    if (product.variants.length > 1) {
        upsellVariantSelect.classList.add('active');
        document.body.classList.add('no-scroll');

        upsellSelectInner.innerHTML = getVariantHTML(product);
        upsellSelectAtc.addEventListener('click', handleAddToCart)
    } else {
        upsellAddToCart(product.variants[0].id, 1, upsellSelectAtc);
    }
}

var upsellWrapper = document.getElementById('product-upsells');

if (upsellWrapper) {
    var upsellItem = upsellWrapper.querySelectorAll('.upsell-item');

    upsellItem.forEach(item => {
        var product = JSON.parse(item.querySelector('script').innerHTML);
        var atc = item.querySelector('[data-atc]');
        console.log({product})
        atc.addEventListener('click', function () {
            handleUpsell(product)
        })
    });

    upsellSelectClose.addEventListener('click', closeVariantSelect);
    upsellSelectOverlay.addEventListener('click', closeVariantSelect);
}
